/**
 * @generated SignedSource<<4de92d70171cbf6efa9ae0952d21cf74>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsCurrentTier_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_viewer">;
  readonly " $fragmentType": "TradeBenefitsCurrentTier_viewer";
};
export type TradeBenefitsCurrentTier_viewer$key = {
  readonly " $data"?: TradeBenefitsCurrentTier_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsCurrentTier_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsCurrentTier_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTradeBenefitsContact_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d71b304f4243c81c7b6c6a93c1560248";

export default node;
